const path = require('path');
const pageloader = require(path.join(__dirname, "pageloader"));

// News api call
const loader = new pageloader(path.join(__dirname, '../pages/news'));
const sortedNewsIDs = loader.getSortedFolderIDs();
const lastNewsID = sortedNewsIDs[sortedNewsIDs.length - 1];
const newsHighlight = require('../pages/news/' + lastNewsID + '/article.json');

const sellers = require('../pages/content/sellers.js');

export default {
  large: [
  
    // {
    //   sectionType: 'subsections',
    //   data: {
    //     color: 'blueOnOffBlack',
    //     video: {
    //       blockModifiers: ['fullSize'],
    //       src: 'WaveDesktop.mp4',
    //       srcMobile: 'WaveMobile.mp4',
    //     },
    //     sections: [
    //       {
    //         full: {
    //           component: 'header-full',
    //           data: {
    //             // text: 'WELCOME TO<br>THE LAND OF<br>FRICTION-FREE<br>C<span style="font-family: \'SpotinTrade\';">O</span>MMERCE',
    //             text: '<div class="headerFull-row">WELCOME TO</div><div class="headerFull-row">THE LAND OF</div><div class="headerFull-row">FRICTION-FREE</div><div class="headerFull-row">C<spotin-com-icon class="icon spotin-com-O1_noMargin headerFull-icon"></spotin-com-icon>MMERCE</div>',
    //             textMobile: '<div class="headerFull-row">WELCOME</div><div class="headerFull-row">TO THE</div><div class="headerFull-row">LAND OF</div><div class="headerFull-row">FRICTION-</div><div class="headerFull-row">FREE</div><div class="headerFull-row">C<spotin-com-icon class="icon spotin-com-O1_noMargin headerFull-icon"></spotin-com-icon>MMERCE</div>',
    //             subText: 'Spotin brings friction-free shopping experiences. Without links or redirections.',
    //             // image: {
    //             //   data: {
    //             //     src: 'sneaker.png'
    //             //   }
    //             // }
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        blockModifiers: ['center'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignTop', 'noMargin', '100Height'],
                component1: {
                  type: 'header-full',
                  data: {
                    blockModifiers: ['noPadding'],
                    text: 'MAKE ANY CONTENT SH<spotin-com-icon class="icon spotin-com-O1_noMargin headerFull-icon"></spotin-com-icon>PPABLE.',
                    textMobile: 'MAKE ANY CONTENT SH<spotin-com-icon class="icon spotin-com-O1_noMargin headerFull-icon"></spotin-com-icon>PPABLE.',
                    links: [
                      {
                        linkText: 'Spotin for Publishers',
                        linkSubText: 'Turn your content into friction-free shopping experiences.',
                        route: 'publishers',
                        icon: 'arrow_right_12px',
                      },
                      {
                        linkText: 'Spotin for Sellers',
                        linkSubText: 'Expand your sales reach and be shoppable in any digital content.',
                        route: 'sellers',
                        icon: 'arrow_right_12px',
                      }
                    ]
                  }
                },
                component3: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['bringToFront', 'maxWidthHeight800', 'ovarlapNextBlock'],
                    loop: true,
                    autoplay: true,
                    src: "startpage_header_animation.json",
                  }
                }
              }
            }
          }
        ]
      },
    },


    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offBlackOnOffWhite',
    //     blockModifiers: ['center'],
    //     sections: [
    //       {
    //         full: {
    //           component: 'animation',
    //           data: {
    //             autoplay: true,
    //             loop: true,
    //             src: "SpotinAnimatedLogo.json",
    //           }

    //         }
    //       }
    //     ]
    //   },
    // },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnOffBlack',
    //     blockModifiers: ['noPadding'],
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-buttons',
    //           data: {
    //             columns: 2,
    //             blockModifiers: ['50Split', 'noMargin', 'endPadding', 'hover'],
    //             header1: 'Spotin for publishers & content makers',
    //             text1: 'Spotin lets you turn your content into revenue streams while keeping visitors on your site. Learn more about making your content shoppable - on your terms.',
    //             link1: {
    //               linkText: 'Read more',
    //               route: 'publishers',
    //               blockModifiers: ['hoverBlack']
    //             },
    //             header2: 'Spotin for brands & sellers',
    //             text2: 'Commerce on the spot, in the right spot, in the right moment, and with the best consumer experience. Learn more about making your products shoppable from within any type of content?',
    //             link2: {
    //               linkText: 'Read more',
    //               route: 'sellers',
    //               blockModifiers: ['hoverBlack']
    //             },
    //           }
    //         }
    //       }
    //     ]
    //   },
    // },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['center','maxTopMargin'],
        sections: [
          {
            full: {
              component: 'video-full',
              data: {
                // blockModifiers: ['sideMargins'],
                autoplay: false,
                muted: false,
                loop: false,          
                src: 'Spotin.mp4',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        // blockModifiers: ['centerBottom'],
        blockModifiers: ['center'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                blockModifiers: ['centerAlignText', 'headerMargin'],
                header2: "Some words on friction-free shopping.",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['logoImages'],
                img1: {
                  src: 'bonnier.svg',
                  alt: "Bonnierförlagen"
                },
                text1: '<p><strong>”To work with Spotin is really a true delight. I have seldomly met a more dedicated team that really engages themselves in building a common business. Besides that their technical competence is really high. Challenges are solved quickly and efficiently and needed development and adaptations in the tool goes from wishes to completed solution sometimes within a matter of hours.<br><br>For us at Bonnier Spotin has in short time developed to be a key-partner in our business development.”</strong></p><p><strong>Anders Larsson</strong>, Head of Consumer Sales, Bonnierförlagen</p>',
                img2: {
                  src: 'voguescandinavia.svg',
                  alt: "Vogue Scandinavia"
                },
                text2: '<p><strong>”Vogue Scandinavia seeks to present the best of fashion, beauty and culture from our Scandinavian point of view and our shopping stories are no exception. We aim to be an online retail destination, where shopping is fun, considered and seamless. Spotin was the perfect partner to help us bring this vision to life.”</strong></p><p><strong>Martina Bonnier</strong>, Editor in chief, Vogue Scandinavia</p>',
                img3: {
                  src: 'sophiebysophie.svg',
                  alt: "Sophie by Sophie"
                },
                text3: '<p><strong>”Being shoppable from within credible content at the very moment our customers\' interest is at its highest, and building relationships with new consumers in collaboration with Spotin and their content commerce solution is really exciting, we look forward to it.”</strong></p><p><strong>Sophie Gyllenhammar Mattsson</strong>, Founder and designer, Sophie by Sophie</p>',
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['noSidePadding','noSideMargin'],
        sections: [
          {
            full: {
              component: 'logo-list',
              data: {
                sellers: sellers,
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['center','noPadding'],
        sections: [
          {
            full: {
              component: 'animation',
              data: {
                // blockModifiers: ['sidePadding'],
                blockModifiers: ['endMargin'],
                src: "New_kind_of_buy_spin_Alt.json",
              }

            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignTop', 'endMargin', 'noColumnMargin'],
                header1: 'A new segment of e-commerce',
                text1: 'Spotin leads the way for a new segment of e-commerce called content commerce. A win-win-win for customers, content makers, and brands.',
                link1: {
                  linkText: 'More on content commerce',
                  route: 'contentcommerce'
                },
                component2: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['300px','mobileTopMargin','noBottomMargin'],
                    loop: true,
                    autoplay: true,
                    src: "Content Commerce Spin.json",
                  }
                }
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Latest news'
              }
            },
            bottom: {
              component: 'article-loader',
              data: {
                columns: 3,
                blockModifiers: ['endMargin','alignTop','wrapColumns','maxChars'],
                startIndex: sortedNewsIDs.length - 1,
                articles: sortedNewsIDs,
                buttonText: 'All news',
                folder: 'news',
                buttonRedirect: '/news',
                sortedIDs: sortedNewsIDs
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['noMargin'],
                header1: 'Come work with us',
                text2: 'Interested in joining us, making e-commerce better, and overthrowing today\'s evil systems?',
                link2: {
                  linkText: 'See open positions',
                  route: 'career',
                }
              }
            },
            // bottom: {
            //   component: 'flex-block',
            //   data: {
            //     blockModifiers: ['endMargin', 'sideMargins'],
            //     component2: {
            //       type: 'animation',
            //       data: {
            //         src: "Join_us.json",
            //       }
            //     }
            //   }
            // }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        blockModifiers: ['center'],
        sections: [
          {
            full: {
              component: 'animation',
              data: {
                blockModifiers: ['endMargin'],
                // blockModifiers: ['sidePadding'],
                src: "Join_us.json",
              }

            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Index.js